const Toast = Mach.requireModule('Toast');
const networkModule = Mach.requireModule('Network');
const indicatorModule = Mach.requireModule('ActivityIndicator');

export const URL = {
  GLOBAL: 'v1/search/globalpage',
  SUG: 'v1/search/suggest',
  HOTWORDS: 'v1/search/searchHotWord', // 热搜词接口
  PRE_SEARCH: 'v1/search/preSearch' // 搜索前置接口
};

/**
 * 搜索引导页的网络请求
 * @param url
 * @param data
 * @param params
 * @param headers
 * @param isPopSearch 是否是热搜词，因为热搜词接口入参需要是对象，所以必须要加dataType，如果在其他接口加dataType会被网关打回，所以另外搞了个对象😮‍💨
 * @returns
 */
export async function Request(url = '', data = {}, params = {}, headers = {}, isPopSearch = false, showIndicator = true): Promise<any> {
  // @ts-ignore
  const requestParams = {
    url,
    method: 'POST',
    params,
    data: { ...data, searchSource: 'keeta_app' },
    headers,
  };
  const popSearchParams = {
    ...requestParams,
    dataType: 'json',
  };
  let finnalParam;
  if (isPopSearch) {
    finnalParam = popSearchParams;
  } else {
    if (showIndicator) {
      indicatorModule.showLoading();
    }
    finnalParam = requestParams;
  }
  // v1/search/globalpage 要特殊处理为 dataType:'json'
  if (url === URL.GLOBAL) {
    finnalParam.dataType = 'json';
  }

  return new Promise<any>((resolve, reject) => {
    networkModule.request(finnalParam, (result: any) => {
      if (showIndicator) {
        indicatorModule.hideLoading();
      }
      if (result.error) {
        console.log(`search request api error: ${JSON.stringify(result.error)}`);
        reject(result.error);
      } else {
        if (result.data && result.data.code === 0) {
          resolve(result.data.data);
        } else {
          const errMsg = result.data.msg || result.data.message;
          console.log(`search request api error: ${errMsg}`);
          if (!isPopSearch) {
            Toast.show(errMsg, 2, {
              type: 'B', // 异常类型
              code: result?.data?.code || '0',
              extraInfo: {
                msg: errMsg,
                method: 'ButtonListComponent.Request',
                url
              }, // 附加异常信息
            });
          }
          reject({
            code: result.data?.code || 0,
            message: errMsg
          });
        }
      }
    });
  });
}

/**
 * 预搜索接口请求
 * @param requestParams
 */
export async function preSearchRequest(requestParams): Promise<any> {
  // @ts-ignore
  const url = URL.PRE_SEARCH;
  const params = {
    url,
    method: 'POST',
    dataType: 'json',
    headers: {},
    params: null,
    data: {
      ...requestParams
    }
  };
    // @ts-ignore
  if (indicatorModule) {
    indicatorModule.showLoading();
  }
  return new Promise<any>((resolve, reject) => {
    networkModule.request(params, (result: any) => {
      if (indicatorModule) {
        indicatorModule.hideLoading();
      }
      if (result.data) {
        if (result.data.code === 0) {
          // 接口请求成功
          console.log('pro search request api success!');
          resolve(result.data.data);
        } else {
          // 接口请求失败
          console.log(`pro search request api fail: ${result.data.msg}`);
          reject(result.data.msg);
        }
      } else {
        // 其他异常
        console.log('pro search request api error!');
        reject('error');
      }
    });
  });
}
